import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class CityService {

  constructor(
    private _http: HttpClient
  ) { }

  getCity() {
    return this._http.get('assets/data/cities.json');
  }

}



// WEBPACK FOOTER //
// E:/MyDemo/Angular2-Demo/Angular-admin/src/app/services/forms/city.service.ts